import { selectComponentState } from 'projectRedux/store';
import { eppDamperTypeAdapter } from '../adapters/eppDamperTypeAdapter';

export const {
  selectAll: selectAllEppDamperTypes,
  selectById: selectEppDamperTypeById,
  selectEntities: selectEppDamperTypeEntities,
} = eppDamperTypeAdapter.getSelectors((state) => selectComponentState(state).eppDamperTypes);
